import { useState, useEffect } from 'react';


const Typewriter = ({ text, delay, dir = "ltr", stop, setLoadingResponse }: { text: string, delay: number, dir?: string, stop?: boolean, setLoadingResponse?: (loading: boolean) => void }) => {
  const [currentText, setCurrentText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (currentIndex < text.length) {
      if (stop !== true) {
        const timeout = setTimeout(() => {
          setCurrentText(prevText => prevText + text[currentIndex]);
          setCurrentIndex(prevIndex => prevIndex + 1);
        }, delay);
        return () => clearTimeout(timeout);
      }
    }else{
      setLoadingResponse && setLoadingResponse(false)
    }
  }, [currentIndex, delay, text, stop]);

  return <div dangerouslySetInnerHTML={{ __html: currentText }} dir={dir} />;
};

export default Typewriter;